import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { NgxPermissionsService } from 'ngx-permissions';

import { AppConfig } from '@root/app.config';
import { ApiService } from '@core/api.service';
import { User } from '@core/user.model';

@Injectable()
export class UserService {
	public permissions: BehaviorSubject<string[] | any> = new BehaviorSubject([]);

	constructor(
		private readonly api: ApiService,
		private readonly appConfig: AppConfig,
		private readonly ngxPermissionsService: NgxPermissionsService
	) {	}

	currentUser(): Observable<User> {
		return this.api.get(this.appConfig.api('me')).pipe(
			map(resp => {
				if (resp.hasOwnProperty('Permissions')) {
					this.permissions.next(resp.Permissions);
				} else {
					this.permissions.next([]);
				}
				return resp;
			})
		);
	}

	checkPermission(checkPermission: string): Observable<boolean> {
		const subject: Subject<boolean> = new Subject();
		this.ngxPermissionsService.permissions$.subscribe(res => {
			subject.next(res.hasOwnProperty(checkPermission));
		});
		return subject;
	}
}
